
// 首页
const home = () => import(/* webpackChunkName: "Index" */ '@/views/homeModule/index')

const homeRouter = [
    {
      path: '/index',
      redirect: '/admin/home',
      component: () => import('@/views/loginModule/index'),
      children: [
        {
          path: '/admin/home',
          name: 'home',
          component: home,
          meta: {
            title: '首页'
          }
        }
      ]
    }
  ]
  export default homeRouter
  
